import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 16px;
  height: 16px;
  color: #111111;
`

const Person = ({ title = 'Person', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 17 19" title={title} {...rest}>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
      <g
        id="surveys-audience-3d"
        transform="translate(-823.000000, -417.000000)"
        stroke="currentColor"
        strokeWidth="0.5"
      >
        <g id="surveys-audience1">
          <g id="Audience" transform="translate(327.000000, 314.000000)">
            <g id="audience-list" transform="translate(104.000000, 51.000000)">
              <g id="table-contents-copy" transform="translate(0.000000, 30.000000)">
                <g id="icon_individual" transform="translate(393.000000, 23.000000)">
                  <path
                    d="M9.375,12.1875 L5.625,12.1875 C2.5184375,12.1875 0,14.5914631 0,17.5568182 C0,17.5568182 15,17.5568182 15,17.5568182 C15,14.5914631 12.4815625,12.1875 9.375,12.1875 Z"
                    id="Shape"
                  />
                  <path
                    d="M2.8125,4.375 C2.8125,1.95875 4.70129464,0 7.03125,0 C9.36120536,0 11.25,1.95875 11.25,4.375 C11.25,6.79125 9.36120536,9.375 7.03125,9.375 C4.70129464,9.375 2.8125,6.79125 2.8125,4.375 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </StyledIcon>
)

Person.displayName = 'Person'
Person.needsWork = true
export default Person
